export const DATE_FORMAT_ISO_8601 = 'yyyy-MM-dd'
export const DATE_TABLE = 'MMM d, yyyy'
export const TIME_FORMAT = 'HH:mm'
export const TABLE_DATETIME_FORMAT = 'MMM d, yyyy HH:mm'
export const DATE_FORMAT_ISO_8601_TIME = 'yyyy-MM-dd HH:mm'
export const DEFAULT_FORMAT = 'dd.MM.yyyy HH:mm'
export const DATE_FORMAT_ISO_8601_TIME_SECONDS = "yyyy-MM-dd'T'HH:mm:ss"
export const HISTORY_FORMAT = 'dd.MM.yyyy HH:mm:ss'
